import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { User } from '../models/user';
import { BaseService } from './base.service';
import { environment } from 'environments/environment';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class FinanceService extends BaseService<any> {

  constructor(private httpCient: HttpClient) {
    super(
      httpCient,
      "finances"
    );
  }



  getFinanceById(id: number): Observable<any> {
    const url = `${environment.apiUrl}/finances/payments/${id}`;
    return this.httpCient.get<any>(url, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleErrors)
      )
  }

  getPayementState(state: any): Observable<any[]> {
    return this.httpCient.get<any[]>(`${environment.apiUrl}/finances/payments/all/${state}`, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleErrors)
      )
  }

  getPaymentProjectId(id: number): Observable<User> {
    const url = `${environment.apiUrl}/finances/payments/all/by/projet/${id}`;
    return this.httpCient.get<User>(url, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleErrors)
      )
  }

  getfinancesOwner(id:number): Observable<User[]> {
    return this.httpCient.get<User[]>(`${environment.apiUrl}/finances/payments/all/by/owner/${id}`, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleErrors)
      )
  }

  getOwnersStateFinances(id: number, state: string): Observable<User[]> {
    return this.httpCient.get<User[]>(`${environment.apiUrl}/finances/payments/all/by/owner/${id}/state/${state}`, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleErrors)
      )
  }

  private handleErrors(error: HttpErrorResponse) {
    let errorMessage;
    console.log(error);
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      if (error.status == 200) {
        errorMessage = { "Code d'erreur": error.status, "message": "OK" };

      } else {
        errorMessage = { "Code d'erreur": error.status, "message": error.error.message };

      }
    }
    return throwError(errorMessage);
  }
}
